import {makeAutoObservable} from "mobx";

/**
 * The type of dataset that is loaded
 */
export type DataType = 'no_data'

/**
 * The type of environment that can be shown
 */
export type ApplicationSection =
    'approval'
    | 'ingestion'
    | 'cleanup'
    | 'analytics'
    | 'synergy'
    | 'settings'
    | 'supplier-360'
    | 'category-profile'

/**
 * Props that are passed to the route wrapper component
 */
export type AppState = {
    fluid?: boolean
    dataType?: DataType
    /**
     * The environment of the dashboard that is being shown
     */
    appSection?: ApplicationSection
}

export const DEFAULT_APP_STATE: AppState = {
    fluid: true,
}

export class RootAppStore {
    get app(): AppState {
        return this.routeApp || this.defaultApp;
    }

    routeApp: AppState | undefined;
    defaultApp: AppState;
    isDevopsMenuOpen = false;
    isDrawerOpen = false;

    constructor() {
        makeAutoObservable(this);
        this.defaultApp = DEFAULT_APP_STATE;
    }

    setApp(app: AppState) {
        this.routeApp = app;
    }

    setIsDevopsMenuOpen(isOpen: boolean) {
        this.isDevopsMenuOpen = isOpen;
    }

    setIsDrawerOpen(isOpen: boolean) {
        this.isDrawerOpen = isOpen;
    }
}
